const K_USER = "CS_USER";
const K_PHONE = "CS_PHONE";
const K_ROLE = "CS_ROLE";

export const csSession = {
  setUser(user) {
    localStorage.setItem(K_USER, JSON.stringify(user));
    localStorage.setItem(K_PHONE, user?.phone || "");
    localStorage.setItem(K_ROLE, user?.role || "");
  },
  getUser() {
    try { return JSON.parse(localStorage.getItem(K_USER) || "null"); }
    catch { return null; }
  },
  getPhone() {
    return localStorage.getItem(K_PHONE) || "";
  },
  getRole() {
    return localStorage.getItem(K_ROLE) || "";
  },
  clear() {
    localStorage.clear();
  }

};

